import invoiceIcon from "../../../../images/icons/buttons/invoice.svg";
const invoiceMenuItems = {
  items: [
    {
      text: "Sprzedaż",
      image: invoiceIcon,
      link: "../invoices",
    },
    {
      text: "Zakupy",
      image: invoiceIcon,
      link: "../purchase-invoices",
    },
  ],
};
export default invoiceMenuItems;
